var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpeditedPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6658 10.5705C11.1536 10.3057 9.19596 8.18059 9.19596 5.59823C9.19596 5.03933 9.28766 4.50184 9.45684 4H7.79004C7.51475 4 7.26629 4.15291 7.1548 4.39041L4.71219 10.2336C4.66519 10.3336 4.64536 10.4432 4.65452 10.5523C4.66368 10.6615 4.70154 10.7667 4.76465 10.8585C4.82776 10.9503 4.91412 11.0257 5.0159 11.078C5.11768 11.1302 5.23164 11.1575 5.34744 11.1575H7.51888L6.36811 16.3278C6.13548 16.9857 6.99991 17.4906 7.51885 17L13.6658 10.5705Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6406 5.58594C10.6406 6.24219 10.8244 6.86344 11.1481 7.38844C11.7519 8.40344 12.8631 9.08594 14.1406 9.08594C15.4181 9.08594 16.5294 8.40344 17.1331 7.38844C17.4569 6.86344 17.6406 6.24219 17.6406 5.58594C17.6406 3.65219 16.0744 2.08594 14.1406 2.08594C12.2069 2.08594 10.6406 3.65219 10.6406 5.58594ZM14.1407 3.33758C14.4169 3.33758 14.6407 3.56143 14.6407 3.83757L14.6408 5.0856L15.8888 5.08563C16.1649 5.08563 16.3888 5.30949 16.3888 5.58563C16.3888 5.86178 16.1649 6.08563 15.8888 6.08563L14.6408 6.0856L14.6408 7.33337C14.6408 7.60951 14.417 7.83337 14.1408 7.83338C13.8647 7.83338 13.6408 7.60953 13.6408 7.33339L13.6408 6.08558L12.393 6.08556C12.1168 6.08555 11.893 5.86169 11.893 5.58555C11.893 5.30941 12.1169 5.08555 12.393 5.08556L13.6408 5.08558L13.6407 3.83759C13.6407 3.56145 13.8646 3.33759 14.1407 3.33758Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpeditedPlus);
export default __webpack_public_path__ + "static/media/expedited-plus.21d5e537e6883af440370c6ba988cb7e.svg";
export { ForwardRef as ReactComponent };